import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as history from "app/main/history";
import { observeResource } from "kea-resource";
import { resources, selectores, createSelectorRx, componentToRx } from "app/main/std";
import { createSelector } from "reselect";
import { validar, DatosPaqueteView } from "./datosView";
import { PagoRealizado } from "../../pago";
import { PrecioPaquetePP } from "./precio";

type Entity = models.NuevoPaquetePPModel;

interface Props {
    value: Entity;
    onChange: (x: Entity) => void;
    onAceptar: () => void;
}

class IfNoRx extends React.PureComponent<{ ifTrue: React.ReactNode, ifFalse: React.ReactNode, value: boolean }> {
    render() {
        return this.props.value ? this.props.ifTrue : this.props.ifFalse;
    }
}
const If = componentToRx(IfNoRx);

export class NuevoPaqueteView extends React.PureComponent<Props> {
    value = (x: Props) => x.value;
    idCliente = (x: Props) => x.value.Paquete.IdCliente;
    model = createSelector(this.value, x => x.Paquete);
    pago = createSelector(this.value, x => x.Pago);
    validarModel = createSelector(this.model, x => validar(x));
    esInvalido = createSelector(this.validarModel, x => kea.validation.hasError(x));

    precio = createSelectorRx(this.model, value => observeResource(resources.PaquetePP.ObtenerPrecioPaquete, value));
    importeAPagar = createSelectorRx(this.precio, x => x.Total);

    onModelChange = (x: models.DatosPaquetePPModel) => {
        const old = this.props.value;
        const next: Entity = {
            ...old,
            Paquete: x
        };
        this.props.onChange(next);
    }

    onPagoChange = (x: models.PagoRealizado) => {
        const old = this.props.value;
        const next: Entity = {
            ...old,
            Pago: x as models.PagoRealizadoDesgloseFeriaModel
        };
        this.props.onChange(next);
    }

    onRegresar = () => history.go("../");

    render() {
        const invalido = this.esInvalido(this.props);
        const idCliente = this.idCliente(this.props);
        const faltanDatos =
            <div className="alert alert-warning">
                <label>Faltan datos</label>
                <p>
                    Termine de llenar los datos para ver los importes
            </p>
            </div>;

        return (
            <div>
                <kea.Title titulo="Venta de paquete de guías prepagadas" onRegresar={this.onRegresar} />
                <kea.Tab
                    items={[
                        {
                            title: "Datos",
                            body:
                                <div>
                                    <DatosPaqueteView value={this.model(this.props)} onChange={this.onModelChange} />
                                    <If value={invalido} ifTrue={faltanDatos} ifFalse={<PrecioPaquetePP value={this.precio(this.props)} />} />
                                </div>
                        }, {
                            title: "Pago",
                            body:
                                <If value={invalido}
                                    ifTrue={faltanDatos}
                                    ifFalse={
                                        <PagoRealizado
                                            idCliente={idCliente}
                                            importeAPagar={this.importeAPagar(this.props)}
                                            value={this.pago(this.props)}
                                            onChange={this.onPagoChange}
                                            onAceptar={this.props.onAceptar}
                                            verPagoContado={true}
                                            verPagoCredito={true}
                                        />}
                                />
                        }
                    ]}
                />

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/paquetespp/edit/form.tsx